import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative w-full',
    menu: 'group',
    button:
      'disabled:text-inactive bg-bg-items-white text-icon-secondary flex size-6 items-center justify-center rounded-full p-0',
    closeIcon: 'text-disabled size-6',
    input: 'heading-m text-m h-12.5 placeholder:normal-case',
    iconSearch: 'absolute right-3 transition-all duration-300'
  },
  variants: {
    empty: {
      true: {
        button: 'pointer-events-none opacity-0'
      },
      false: {
        iconSearch: 'right-[unset] left-3',
        input: 'pl-12.5'
      }
    },
    focused: {
      true: {
        iconSearch: 'right-[unset] left-3',
        input: 'pl-12.5'
      }
    }
  }
});
